module.exports = __webpack_public_path__ + "static/media/book.dc7aaa82.svg";